/* eslint-disable react/forbid-dom-props, react/forbid-component-props */
import classnames from 'classnames';
import { isEmpty, isFunction } from 'lodash';
import React, { useMemo } from 'react';
import { CellMeasurer } from 'react-virtualized';
import StatusAddon from '../../../dataViews/NextTree/addons/StatusAddon';
import useHelpNote from '../../../utils/Translations/useHelpNote';
import useLayoutDirection from '../../../utils/Translations/useLayoutDirection';
import { RETURN_TYPE } from './SelectBox';
import styles from './SelectBox.scss';
const SelectBoxMenuItem = ({ item, onOptionLabel, onOptionContentRender, returnType = RETURN_TYPE.STRING, cache, index, isItemCentered = false, style, handleOnChange, parent, dataCy, }) => {
    const { isLayoutRTL } = useLayoutDirection();
    const getHelpNoteTooltipTitle = useHelpNote();
    const { label, disabled, aClass, value, active, divider, header, status, title, } = item;
    const optionLabel = useMemo(() => {
        const val = isEmpty(title) ? label : title;
        return onOptionLabel ? onOptionLabel(value) : val;
    }, [label, onOptionLabel, value, title]);
    const optionTitle = useMemo(() => getHelpNoteTooltipTitle((isEmpty(title) ? optionLabel : title) || ''), [getHelpNoteTooltipTitle, optionLabel, title]);
    const body = useMemo(() => {
        if (isFunction(onOptionContentRender)) {
            return returnType === RETURN_TYPE.OPTION
                ? onOptionContentRender(value)
                : onOptionContentRender(item);
        }
        return label && <span>{label}</span>;
    }, [returnType, value, onOptionContentRender, item, label]);
    return (<CellMeasurer cache={cache} columnIndex={0} parent={parent} rowIndex={index}>
      {({ registerChild }) => (<li ref={registerChild} className={classnames({
        disabled,
        active,
        divider,
        'dropdown-header': header && label,
        'no-margin-top': header && label,
        'text-center': isItemCentered,
        'text-right': isLayoutRTL && !isItemCentered,
    })} style={style} title={optionTitle}>
          {disabled ? (<span className={styles.optionLabelContainer}>
              {body}
              {body && <hr className="ml-10 mt-10 no-margin-right w-100"/>}
            </span>) : (<a className={classnames(aClass, 'pl-15')} data-cy={dataCy} title={optionTitle} onClick={handleOnChange}>
              {body}
              <StatusAddon className={classnames('display-inline-block text-size-small', styles.statusAddon)} status={status}/>
            </a>)}
        </li>)}
    </CellMeasurer>);
};
export default SelectBoxMenuItem;
